import { FormControl, FormErrorMessage, FormLabel, Input } from '@chakra-ui/react';
import { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import { FieldError, FieldErrorsImpl, FieldValues, Merge, UseFormRegister } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';

interface Props {
    id: string;
    value: string | Date;
    label: string;
    type?: string;
    onChange: (value: string) => void;
    isRequired?: string | boolean;
    flex?: number;
    isCompact?: boolean;
    isInvalid?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | null;
    minLength?: number;
    maxLength?: number;
    noPadding?: boolean;
    isDisabled?: boolean;
    validate?: (value: string) => any;
    register: UseFormRegister<FieldValues>;
}

const InputComponent: FC<Props> = ({
    id,
    value,
    label,
    onChange,
    type = 'text',
    flex = 1,
    isRequired = false,
    isCompact = false,
    isInvalid = null,
    isDisabled = false,
    minLength = 0,
    maxLength = 0,
    validate,
    noPadding = false,
    register,
}) => {
    const [error, setError] = useState('');

    useEffect(() => {
        if (isInvalid?.message) {
            setError(isInvalid?.message as string);
        } else {
            setError('');
        }
    }, [isInvalid]);

    const handleOnChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            if (event.target) {
                onChange(event.target.value ?? '');
            }
        },
        [onChange],
    );

    return (
        <FormControl
            flex={flex}
            variant="floating"
            paddingBottom={isCompact || noPadding ? '0' : '20px'}
            isInvalid={isInvalid !== null}
            isDisabled={isDisabled}
        >
            <Input
                /* id={id} */
                variant={isCompact ? 'compact' : 'standard'}
                placeholder=" "
                type={type}
                {...register(id, {
                    required: isRequired ? 'Questo campo è obbligatorio' : false,
                    minLength: minLength
                        ? { value: minLength, message: `Questo campo deve avere almeno ${minLength} caratteri` }
                        : undefined,
                    maxLength: maxLength
                        ? {
                              value: maxLength,
                              message: `Questo campo deve avere al massimo ${maxLength} caratteri`,
                          }
                        : undefined,
                    value: value,
                    disabled: isDisabled,
                    onChange(event) {
                        handleOnChange(event as ChangeEvent<HTMLInputElement>);
                    },
                    validate: validate,
                })}
                backgroundColor="transparent"
                color="gray.600"
                _autofill={{
                    WebkitTextFillColor: 'var(--chakra-colors-gray-600)',
                    WebkitBoxShadow: '0 0 0px 1000px white inset',
                    transition: 'background-color 5000s ease-in-out 0s',
                }}
            />
            <FormLabel htmlFor={id}>
                {label}
                {isRequired && ' *'}
            </FormLabel>
            <FormErrorMessage position="absolute" fontSize={12}>
                {error}
            </FormErrorMessage>
        </FormControl>
    );
};

export default InputComponent;
